import { ResolutionString, SeriesType, Timezone } from '../charting_library';

// Line rendering constants
export const OFFSET_SPACING = 20;
export const LINE_LENGTH = 25;
export const DEFAULT_RESOLUTION: ResolutionString = '15' as ResolutionString;
export const DEFAULT_CHART_TYPE: SeriesType = SeriesType.Candles;
export const DEFAULT_STARRED_RESOLUTIONS: ResolutionString[] = [
  '5',
  '60',
  '1D',
] as ResolutionString[];
export const DEFAULT_STARRED_CHART_TYPES: SeriesType[] = [];

// Supported TradingView timezones
export const SUPPORTED_TIMEZONES = [
  'Etc/UTC',
  'Africa/Cairo',
  'Africa/Johannesburg',
  'Africa/Lagos',
  'America/Argentina/Buenos_Aires',
  'America/Bogota',
  'America/Caracas',
  'America/Chicago',
  'America/El_Salvador',
  'America/Juneau',
  'America/Los_Angeles',
  'America/Mexico_City',
  'America/New_York',
  'America/Phoenix',
  'America/Santiago',
  'America/Sao_Paulo',
  'America/Toronto',
  'America/Vancouver',
  'Asia/Almaty',
  'Asia/Ashkhabad',
  'Asia/Bahrain',
  'Asia/Bangkok',
  'Asia/Chongqing',
  'Asia/Dubai',
  'Asia/Ho_Chi_Minh',
  'Asia/Hong_Kong',
  'Asia/Jakarta',
  'Asia/Jerusalem',
  'Asia/Kathmandu',
  'Asia/Kolkata',
  'Asia/Kuwait',
  'Asia/Manila',
  'Asia/Muscat',
  'Asia/Qatar',
  'Asia/Riyadh',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Taipei',
  'Asia/Tehran',
  'Asia/Tokyo',
  'Atlantic/Reykjavik',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Perth',
  'Australia/Sydney',
  'Europe/Amsterdam',
  'Europe/Athens',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Bratislava',
  'Europe/Brussels',
  'Europe/Bucharest',
  'Europe/Copenhagen',
  'Europe/Dublin',
  'Europe/Helsinki',
  'Europe/Istanbul',
  'Europe/Lisbon',
  'Europe/London',
  'Europe/Luxembourg',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Moscow',
  'Europe/Oslo',
  'Europe/Paris',
  'Europe/Prague',
  'Europe/Rome',
  'Europe/Stockholm',
  'Europe/Tallinn',
  'Europe/Vilnius',
  'Europe/Warsaw',
  'Europe/Zurich',
  'Pacific/Auckland',
  'Pacific/Chatham',
  'Pacific/Fakaofo',
  'Pacific/Honolulu',
  'Pacific/Norfolk',
  'US/Mountain',
] satisfies Timezone[];

// Volume-based indicators that should be hidden when volume data is not available
export const VOLUME_BASED_INDICATORS = [
  'Accumulation/Distribution',
  'Chaikin Money Flow',
  'Ease of Movement',
  'Elders Force Index',
  'Klinger Oscillator',
  'Money Flow Index',
  'Net Volume',
  'On Balance Volume',
  'Price Volume Trend',
  'VWAP',
  'Volume Oscillator',
  'Volume',
] as const;
